import type { FaireProductEntity } from "../../entity_types/product";

export const p_mvgghnwhan: FaireProductEntity = {
  token: "p_mvgghnwhan",
  type: "product",
  name: "Sailboat Skinny Scarf",
  brandToken: "b_bganl3cn3b",
  brandName: "VERLOOP | knits",
  imageUrl:
    "https://cdn.faire.com/fastly/207d64ee084b476d722f87b4241e09947cbd034b96bdcf7fda4d452218f2c528.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed54b03650215e8bf5dddaa01ad73268f13343d4bffb965861598120b0f7728a.jpeg",
    "https://cdn.faire.com/fastly/42ecd6b17f9eeb8876a7c9f32beeda098ca4c06083494cc2bd41a1e02f2827f2.jpeg",
    "https://cdn.faire.com/fastly/92ba7390f14af10015d83de3668780103b0b57d7f133ec96f39efff41334dc73.jpeg",
    "https://cdn.faire.com/fastly/00c8890a60fdc9fc31c318b37f17ab2c2ef1f5ed8814e31ff2e24a24a2258a07.jpeg",
    "https://cdn.faire.com/fastly/898127084abc17d48c9aa5e334a83747a8e054dab66df83bbad06c43557a1d37.jpeg",
    "https://cdn.faire.com/fastly/b537ada156c8069c84945a6b2db5f2b9bb8c79e2e411b5af6d8df81f2faf4d70.jpeg",
    "https://cdn.faire.com/fastly/808c65a437581c377d4b9ee089893a84cc500a1f5771bf90eadeb22488350de9.jpeg",
    "https://cdn.faire.com/fastly/8af61d4e5f0c71561b3ba7878f5bcf48f0306f9c1c9648873966a9c2f48f4aee.jpeg",
    "https://cdn.faire.com/fastly/33e83f085f963b45a647c7b34f128cc7952e40dfa7061dfd606cd4966c78ed50.jpeg",
  ],
  priceDollars: 30,
  description:
    'A vintage-inspired long skinny scarf knitted with alternating blocks of triangles and stripes. Colorful, reversible, and unisex. For indoor and outdoor wear. Can be tied and wrapped in many different ways depending on weather or mood. Knit with new and repurposed deadstock yarn.\n\nDetails \n100% Soft Acrylic\nMachine wash cold gentle cycle, dry flat\n5"W x 84"L\n\n',
  tags: [],
  msrpDollars: 65,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:41.740Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
